var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
const BASE_URL = "/aviso/notice";
export default class NoticeService {
    /**
     * Retrieves all notices for a person by their person id
     *
     * @param {string} personId - The id of the person to retrieve notices for
     */
    static getNoticesForPerson(personId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/getNoticesForPerson", {
                personId,
            });
        });
    }
    /**
     * Marks a notice as seen
     *
     * @param {number} noticeId - The id of the noticed to be marked as seen
     * @param {string} personId - The id of the person to retrieve notices for
     */
    static markSeen(noticeId, personId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/markSeen", {
                noticeId,
                personId,
            });
        });
    }
}
